export default __webpack_public_path__ + "static/media/icon_lunch_dining.9bd289e2.svg";